// services/api/maintenanceApi.ts
import api from '../../utils/axios';
import { toast } from '../../utils/toast';
import { useState, useCallback } from 'react';
import { GenericItem, MaintenanceDto } from '../../components/types/generic.types';

const useMaintenanceApi = (entityPath: string) => {
  const [isLoading, setIsLoading] = useState(false);
  const baseUrl = '/mantenimiento';

  const handleError = (error: any) => {
    const message = error.response?.data?.message || 'Ha ocurrido un error';
    toast.error('Error');
  };

  const handleSuccess = (message: string) => {
    toast.success('Éxito');
  };

  const getAll = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await api.post<GenericItem[]>(`${baseUrl}/${entityPath}/findAll`);     
      // Filtrar solo los items no eliminados
      const filteredData = response.data.filter(item => item.Eliminado === false);
    
      return filteredData;
    } catch (error) {
      console.error('API Error:', error);
      handleError(error);
      return [];
    } finally {
      setIsLoading(false);
    }
  }, [entityPath]);

  const create = useCallback(async (data: MaintenanceDto) => {
    setIsLoading(true);
    try {
      const response = await api.post(`${baseUrl}/${entityPath}/create`, {
        ...data,
        Eliminado: false
      });
      handleSuccess('Registro creado exitosamente');
      return response.data;
    } catch (error) {
      handleError(error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, [entityPath]);

  const update = useCallback(async (id: number, data: MaintenanceDto) => {
    setIsLoading(true);
    try {
      const response = await api.post(`${baseUrl}/${entityPath}/update/${id}`, data);
      handleSuccess('Registro actualizado exitosamente');
      return response.data;
    } catch (error) {
      handleError(error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, [entityPath]);

  const softDelete = useCallback(async (id: number) => {
    setIsLoading(true);
    try {
      await api.post(`${baseUrl}/${entityPath}/softDelete/${id}`);
      handleSuccess('Registro eliminado exitosamente');
    } catch (error) {
      handleError(error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, [entityPath]);

  return {
    isLoading,
    getAll,
    create,
    update,
    remove: softDelete
  };
};

export { useMaintenanceApi };